import {
  GET_FINAL_CANDIDATE,
  FINAL_CANDIDATE_LOADING,
  SET_FINAL_CANDIDATE_ITEMS_PER_PAGE,
  CHANGE_CURRENT_FINAL_CANDIDATE_PAGE,
  SEARCH_FINAL_CANDIDATE,
  FILTER_FINAL_CANDIDATE_ROLES,
  FILTER_FINAL_CANDIDATE_SKILL,
  FILTER_FINAL_CANDIDATE_STATUS,
  VIEW_CLIENT_FEEDBACK,
  RESET_FINAL_TABLE_FILTERS,
} from "../actions/finalCandidateAction";

const initialState = {
  FinalCandidateList: [],

  FinalCandidateAppliedRolesFilter: [],
  FinalCandidateAppliedSkillFilter: [],
  FinalCandidateAppliedStatusFilter: [],
  FinalCandidateTotalResults: [],
  FinalCandidateCurrentPage: 1,
  FinalCandidatePageIds: [],
  FinalCandidateTotalPages: null,
  FinalCandidateSearchText: "",
  FinalCandidateResultsPerPage: 5,
  FinalCandidateRolesFilter: [],
  FinalCandidateSkillsFilter: [],
  FinalCandidateStatusFilter: [],
  FinalCandidateUserDetails: [],

  fetchingData: true,
};

const finalSelectionCandidatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FINAL_CANDIDATE: {
      return {
        ...state,
        FinalCandidateList: action.payload.result.results,
        FinalCandidateTotalResults: action.payload.result.total_results,
        FinalCandidateTotalPages: action.payload.result.total_pages,
        FinalCandidatePageIds: action.payload.result.page_ids,
        FinalCandidateRolesFilter: action.payload.filter_data.roles,
        FinalCandidateSkillsFilter: action.payload.filter_data.skills,
        fetchingData: false,
      };
    }
    case FINAL_CANDIDATE_LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }
    case SEARCH_FINAL_CANDIDATE: {
      return {
        ...state,
        FinalCandidateSearchText: action.payload,
      };
    }
    case SET_FINAL_CANDIDATE_ITEMS_PER_PAGE: {
      return {
        ...state,
        FinalCandidateResultsPerPage: action.payload,
      };
    }
    case CHANGE_CURRENT_FINAL_CANDIDATE_PAGE: {
      return {
        ...state,
        FinalCandidateCurrentPage: action.payload,
      };
    }
    case FILTER_FINAL_CANDIDATE_ROLES: {
      return {
        ...state,
        FinalCandidateAppliedRolesFilter: action.payload,
      };
    }
    case FILTER_FINAL_CANDIDATE_STATUS: {
      return {
        ...state,
        FinalCandidateAppliedStatusFilter: action.payload,
      };
    }
    case FILTER_FINAL_CANDIDATE_SKILL: {
      return {
        ...state,
        FinalCandidateAppliedSkillFilter: action.payload,
      };
    }
    case VIEW_CLIENT_FEEDBACK: {
      return {
        ...state,
        FinalCandidateUserDetails: action.payload,
      };
    }
    case RESET_FINAL_TABLE_FILTERS: {
      return {
        ...state,
        FinalCandidateSearchText: "",
        FinalCandidateAppliedRolesFilter: [],
        FinalCandidateAppliedSkillFilter: [],
        FinalCandidateAppliedStatusFilter: [],
      };
    }

    default:
      return state;
  }
};
export default finalSelectionCandidatesReducer;
